export default __webpack_public_path__ + "static/media/saveXMLIcon_disabled.49fdc4b8.svg";